import format from 'date-fns/format';
import fromUnixTime from 'date-fns/fromUnixTime';

/**
 * Renders an agent's first login as a local 24h time of day (e.g. 09:30).
 * `timestamp` is unix seconds of the day's first offline -> online transition,
 * empty when the agent never came online that day.
 */
export const formatFirstLoginTime = timestamp =>
  timestamp ? format(fromUnixTime(timestamp), 'HH:mm') : '—';

/**
 * Comparator factory: sorts rows by an ascending numeric `key` (e.g. first
 * login unix time), pushing rows missing that value to the end and breaking
 * ties (including all-missing) by comparing `fallbackKey` alphabetically.
 */
export const sortByKey = (key, fallbackKey) => (a, b) => {
  if (!a[key] && !b[key]) {
    return a[fallbackKey].localeCompare(b[fallbackKey]);
  }
  if (!a[key]) return 1;
  if (!b[key]) return -1;
  return a[key] - b[key];
};
